import { forwardRef, type Ref, type SVGProps } from "react";

function SvgLockedFilled(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.333 1A3.333 3.333 0 0 0 5 4.333V5.55A2.5 2.5 0 0 0 3 8v3.667a2.5 2.5 0 0 0 2.5 2.5h5.667a2.5 2.5 0 0 0 2.5-2.5V8a2.5 2.5 0 0 0-2-2.45V4.333A3.333 3.333 0 0 0 8.333 1m2.334 4.5V4.333a2.333 2.333 0 0 0-4.667 0V5.5zM8.333 8.333a.5.5 0 0 1 .5.5v2a.5.5 0 1 1-1 0v-2a.5.5 0 0 1 .5-.5"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgLockedFilled);
export default ForwardRef;
